import { WatchQueryFetchPolicy } from '@apollo/client'
import { useAudienceDisplayLanguage } from '../../../hooks/audience/useAudienceDisplayLanguage'
import useGetDraftAudience from '../../../hooks/audience/useGetDraftAudience'
import { useProjectType } from '../../Project/Project.hooks'
import AudienceSummaryControl from './AudienceSummary.control'
import AudienceSummaryLoading from './AudienceSummaryLoading'

interface Props {
  showTitle?: boolean
  showQuotas?: boolean
  // Override the control's empty-state copy (its default instructs the user
  // to "Edit targeting and screening", which is wrong on locked surfaces).
  emptySubtitle?: string
  emptyDescription?: string
  // Callers showing a survey other than the ambient one need `network-only` so
  // the cross-market normalised audience cache isn't read back.
  audienceFetchPolicy?: WatchQueryFetchPolicy
}

const AudienceSummary = ({
  showTitle,
  showQuotas = true,
  emptySubtitle,
  emptyDescription,
  audienceFetchPolicy
}: Props) => {
  const { isFdChat } = useProjectType()

  const { draftAudience, loading, error } = useGetDraftAudience({
    fetchPolicy: audienceFetchPolicy
  })
  const marketLanguage = useAudienceDisplayLanguage()

  if (error) return <div>Error loading audience summary</div>
  if (loading || !draftAudience) return <AudienceSummaryLoading />

  return (
    <AudienceSummaryControl
      audiences={draftAudience.members}
      validationErrors={draftAudience.validationErrors}
      marketLanguage={marketLanguage}
      showTitle={showTitle}
      showQuotas={showQuotas}
      emptySubtitle={emptySubtitle ?? (isFdChat ? '' : undefined)}
      emptyDescription={
        emptyDescription ??
        (isFdChat
          ? 'No questions added. All qualifying questions and responses will appear here.'
          : undefined)
      }
    />
  )
}

export default AudienceSummary
